<template>
  <div id="popular_bundles">
    <slider-section id="normal-cards" method="getPage" :obj="bundleRepo" routing="popular-bundles" sliderHolder="popularBundles" :data="info" :key="key"/>
  </div>
</template>

<script>
import SliderSection from '../../components/sections/SliderSection'
import BundleSliderRepository from '../../repositories/BundleSliderRepository'
import $ from 'jquery'
// import gc from '../../utils/gc'
export default {
  name: 'PopularBundles',
  components: { SliderSection },
  data () {
    return {
      info: {
        main: { sectionId: 'popular_bundles', cardType: 'bundle', title: this.$t('popularBundles.title'), description: this.$t('popularBundles.desc'), image: '' },
        slider: []
      },
      page: 0,
      size: 5,
      totalElements: 0,
      bundleRepo: new BundleSliderRepository(),
      show: false,
      error: false,
      visited: [0],
      shouldBeDragged: 0,
      key: 0
    }
  },
  created () {
    this.$watch(() => {
      return this.$store.state.selectedNumber
    }, (val) => {
      this.key++
    })
  },
  mounted () {
    this.arabic()
  },
  methods: {
    arabic () {
      if (this.$lang === 'ar') {
        // this.info.main.image = 'bundlesArabic.png'
        $('#popular_bundles').addClass('ar')
      } else {
        $('#popular_bundles').addClass('en')
      }
    },
    getPageSize (val) {
      // this.size = val + 1
    }
  }
}
</script>

<style scoped>
#popular_bundles.ar {
  background: url("../../assets/images/circles-back-ar.png") no-repeat right;
}
#popular_bundles.en {
  background: url("../../assets/images/circles-back-en.png") no-repeat;
}

</style>
